/**
 * Created by yanxiaojun617@163.com on 12-27.
 */
import { Injectable } from '@angular/core';
import { ToastController, NavController, LoadingController, Platform, Loading, AlertController } from 'ionic-angular';
import { App } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { AppVersion } from '@ionic-native/app-version';
import { File } from '@ionic-native/file';
import { FileTransfer, FileTransferObject } from '@ionic-native/file-transfer';
import moment from 'moment';
import { CalendarController, DayConfig } from "ion2-calendar/dist";
import { IS_APP, REQUEST_TIMEOUT,
} from "./Constants";
import { GlobalData } from "./GlobalData";
import { Observable } from "rxjs";
import { Http, Response } from "@angular/http";
import { Utils } from "./Utils";
import { Logger } from "./Logger";
import { SearchModel } from '../models/SearchModel';
import { ThemeableBrowser, ThemeableBrowserOptions, ThemeableBrowserObject } from '@ionic-native/themeable-browser';
import { FileOpener } from '@ionic-native/file-opener';
@Injectable()
export class NativeService {
  private loading: Loading;
  private loadingIsOpen: boolean = false;
  static options: ThemeableBrowserOptions = {
    statusbar: {
      color: '#ffffffff'
    },
    toolbar: {
      height: 44,
      color: '#26a6c3'
    },
    title: {
      color: '#ffffff',
      showPageTitle: true
    },
    backButton: {
      wwwImage: 'theme/img/webviewBar/angle_left.png',
      wwwImagePressed: 'theme/img/webviewBar/angle_left_pressed.png',
      wwwImageDensity: 1.5,
      event: 'backPressed'
    },
    closeButton: {
      wwwImage: 'theme/img/webviewBar/cross.png',
      wwwImagePressed: 'theme/img/webviewBar/cross_pressed.png',
      wwwImageDensity: 1.5,
      align: 'right',
      event: 'closePressed'
    },
    backButtonCanClose: true
  };


  constructor(private app: App,
    private platform: Platform,
    private appVersion: AppVersion,
    private toastCtrl: ToastController,
    private alertCtrl: AlertController,
    private statusBar: StatusBar,
    private splashScreen: SplashScreen,
    private loadingCtrl: LoadingController,
    private globalData: GlobalData,
    public logger: Logger,
    public transfer: FileTransfer,
    public calendarCtrl: CalendarController,
    public searchModel: SearchModel,
    public file: File,
    public themeableBrowser: ThemeableBrowser,
    public http: Http,
    public fileOpener: FileOpener) {
  }

  /**
   * 检查app是否需要升级
   */
  detectionUpgrade(showDialog: boolean = false) {
    if (!this.isMobile()) {
      return;
    }

    //这里连接后台获取app最新版本号,然后与当前app版本号(this.getVersionNumber())对比
    //版本号不一样就需要申请,不需要升级就return
    this.http.post(APP_SERVE_URL + "AppVersion", {}).map((res: Response) => res.json()).subscribe(res => {
      if (!res) {
        this.logger.log('', '从app升级获取版本信息失败', { url: APP_SERVE_URL + "AppVersion" });
        return;
      };

      this.getVersionNumber().subscribe(currentNo => {

        if (this.isAndroid()) {          
          if (res.result.appVersion <= currentNo) {
            if (showDialog) {
              this.alert("已经是最新版本了");
            };
          } else {
            var _buttons = [
              { text: '取消' },
              {
                text: '立刻升级',
                handler: () => {
                  this.openUrlByBrowser(res.result.appUpdateUrl_android);
                  //    this.downloadApp(res.result.appUpdateUrl_android, res.result.appForcedUpdate);
                }
              }];

            if (res.result.appForcedUpdate) {
              _buttons.splice(0, 1);
            }
            this.alertCtrl.create({
              enableBackdropDismiss: false,
              title: '发现新版本',
              subTitle: res.result.appUpdateMsg,
              buttons: _buttons
            }).present();
          }
        } else {
          //苹果         
          if (res.result.iosAppVersion > currentNo) {
            var _buttons = [
              { text: '取消' },
              {
                text: '立刻升级',
                handler: () => {
                  this.openUrlByBrowser(res.result.appUpdateUrl_ios);
                }
              }];

            if (res.result.appForcedUpdate) {
              _buttons.splice(0, 1);
            }
            this.alertCtrl.create({
              enableBackdropDismiss: false,
              title: '发现新版本',
              subTitle: res.result.appUpdateMsg,
              buttons: _buttons
            }).present();
          }
        }
      });
    });
  };

  /**
 * 通过浏览器打开url
 */
  openUrlByBrowser(url: string): void {
    this.themeableBrowser.create(url, '_system', NativeService.options);
    //this.inAppBrowser.create(url, '_system');
  }



  /**
* 通过自己打开url
*/
  openUrlBySelf(url: string): void {
    this.themeableBrowser.create(url, '_self', NativeService.options);
    //this.inAppBrowser.create(url);
  }

  /**
   * 下载安装app
   */
  downloadApp(appDownLoadUrl: string, appForcedUpdate: boolean) {
    if (this.isAndroid()) {
      let alert = this.alertCtrl.create({
        title: '下载进度：0%',
        enableBackdropDismiss: false
      });
      if (!appForcedUpdate) {
        alert.addButton('后台下载');
      }
      alert.present();

      const fileTransfer: FileTransferObject = this.transfer.create();
      const apk = this.file.externalDataDirectory + 'tts-hanzhong-android.apk'; //apk保存的目录
      fileTransfer.download(appDownLoadUrl, apk).then((x) => {
        this.fileOpener.open(apk, 'application/vnd.android.package-archive').then(x => {

        }, x => {
          this.showToast(`安装失败：${x}`);
        });
        //window['install'].install(apk.replace('file://', ''));
      });

      fileTransfer.onProgress((event: ProgressEvent) => {
        let num = Math.floor(event.loaded / event.total * 100);
        if (num === 100) {
          if (!appForcedUpdate) {
            alert.dismiss();
          } else {
            let title = document.getElementsByClassName('alert-title')[0];
            title && (title.innerHTML = '下载进度：' + num + '%');
          }
        } else {
          let title = document.getElementsByClassName('alert-title')[0];
          title && (title.innerHTML = '下载进度：' + num + '%');
        }
      });
    }
    if (this.isIos()) {
      //
      //this.openUrlByBrowser(APP_DOWNLOAD);
    }
  }

  login() {
    this.app.getActiveNav().push('LoginBackgroundSliderPage');
    //this.app.getActiveNav().push('LoginPage');
    //this.navController.push('LoginPage');LoginSliderPage
  }


  /**
   * 使用默认状态栏
   */
  statusBarStyleDefault(): void {
    this.statusBar.styleDefault();
  }

  /**
   * 隐藏启动页面
   */
  splashScreenHide(): void {
    this.splashScreen.hide();
  }

  /**
   * 获取网络类型 如`unknown`, `ethernet`, `wifi`, `2g`, `3g`, `4g`, `cellular`, `none`
   */
  getNetworkType(): string {
    if (!this.isMobile()) {
      return 'wifi';
    }
    return '4g';
  }

  /**
 * 获得app版本号,如0.01
 * @description  对应/config.xml中version的值
 */
  getVersionNumber(): Observable<string> {
    return Observable.create(observer => {
      this.appVersion.getVersionNumber().then((value: string) => {
        observer.next(value);
      }).catch(err => {
        this.logger.log(err, '获得app版本号失败');
      });
    });
  }


  selectDrvDate(): Observable<any> {
    return Observable.create(observer => {
      let drvDate = moment(this.searchModel.drvDate);
      let today = moment(this.searchModel.minDate);
      let _dayConfigs: Array<DayConfig> = [
        {
          date: today.toDate(),
          subTitle: '今天',
          marked: false,
        },
        {
          date: today.add(1, 'd').toDate(),
          subTitle: '明天',
          marked: false
        },
        {
          date: today.add(1, 'd').toDate(),
          subTitle: '后天',
          marked: false
        }
      ];
      if (this.globalData.festival) {
        this.globalData.festival.forEach(x => {
          _dayConfigs.push({
            date: moment(x.date).toDate(),
            subTitle: x.title,
            disable: true,
          });
        });
      }
      this.calendarCtrl.openCalendar({
        from: moment(this.searchModel.minDate).toDate(),
        to: moment(this.searchModel.maxDate).toDate(),
        title: '选择日期',
        closeLabel: '取消',
        weekStart: 1,
        monthFormat: 'yyyy 年 MM 月',
        color: 'danger',
        defaultDate: moment(this.searchModel.drvDate).toDate(),
        weekdays: "日_一_二_三_四_五_六".split("_"),
        autoDone: true,
        daysConfig: _dayConfigs
      })
        .then(res => {
          let d = moment(res.time).format('YYYY-MM-DD');
          observer.next(d);
          this.searchModel.drvDate = d;
        }, cancel => {
          console.log(cancel);
        });
    });
  }

  selectCharteredDrvDate(selectDate: Date, ) {

    return Observable.create(observer => {
      let today = moment(this.searchModel.minDate);
      let _dayConfigs: Array<DayConfig> = [
      ];
      this.calendarCtrl.openCalendar({
        from: moment(this.searchModel.minDate).toDate(),
        title: '选择日期',
        to: moment(this.searchModel.minDate).add(90, 'd').toDate(),
        closeLabel: '取消',
        weekStart: 1,
        autoDone: true,
        color: 'danger',
        defaultDate: selectDate,
        defaultScrollTo: selectDate,
        monthFormat: 'yyyy 年 MM 月',
        weekdays: "日_一_二_三_四_五_六".split("_"),
        daysConfig: _dayConfigs
      })
        .then(res => {
          let d = moment(res.time).toDate();
          observer.next(d);
        }, cancel => {
          console.log(cancel);
        });
    });
  }

  selectTourismDrvDate(selectDate: Date, availableDates: any[]): Observable<Date> {
    return Observable.create(observer => {
      let today = moment(this.searchModel.minDate);
      let _dayConfigs: Array<DayConfig> = [
      ];
      availableDates.forEach(x => {
        _dayConfigs.push({
          date: x.date,
          subTitle: `余${x.lastSeats}张`,
          disable: false,
          marked: true
        });
      });
      this.calendarCtrl.openCalendar({
        from: moment(this.searchModel.minDate).toDate(),
        title: '选择日期',
        to: moment(this.searchModel.minDate).add(-1, 'd').toDate(),
        closeLabel: '取消',
        weekStart: 1,
        autoDone: true,
        color: 'danger',
        defaultDate: selectDate,
        defaultScrollTo: selectDate,
        monthFormat: 'yyyy 年 MM 月',
        weekdays: "日_一_二_三_四_五_六".split("_"),
        daysConfig: _dayConfigs
      })
        .then(res => {
          let d = moment(res.time).toDate();
          observer.next(d);
        }, cancel => {
          console.log(cancel);
        });
    });
  }

  /**
   * 判断是否有网络
   */
  isConnecting(): boolean {
    return this.getNetworkType() != 'none';
  }

  /**
  * 获取下单来源
  */
  getOrderResource(): string {
    if (!IS_APP) return 'Touch';
    if (this.isAndroid()) return 'Android';
    if (this.isIos()) return 'Ios';
    if (this.isVisualMobile()) return 'Touch';
    return 'Pc';
  }

  isVisualMobile(): boolean {
    return this.platform.is('mobile');
  }

  /**
   * 是否真机环境
   */
  isMobile(): boolean {
    //cordova
    return this.platform.is('mobile') && this.platform.is('cordova');
    //return this.platform.is('mobile') && !this.platform.is('mobileweb');
  }

  /**
   * 是否android真机环境
   */
  isAndroid(): boolean {
    return this.isMobile() && this.platform.is('android');
  }

  /**
   * 是否ios真机环境
   */
  isIos(): boolean {
    return this.isMobile() && (this.platform.is('ios') || this.platform.is('ipad') || this.platform.is('iphone'));
  }

  alert(title: string, subTitle: string = "", ): void {
    this.alertCtrl.create({
      title: title,
      subTitle: subTitle,
      buttons: [{ text: '确定' }]
    }).present();
  }
  confirm(title: string = "确认", msg: string = "你确认吗？", ): Observable<boolean> {
    return Observable.create(observer => {
      let alert = this.alertCtrl.create({
        title: title,
        message: msg,
        buttons: [
          {
            text: '取消',
            role: 'cancel',
            handler: () => {
              observer.next(false);
            }
          },
          {
            text: '确定',
            handler: () => {
              observer.next(true);
            }
          }
        ]
      });
      alert.present();
    });
  }

  /**
   * 统一调用此方法显示提示信息
   * @param message 信息内容
   * @param duration 显示时长
   */
  showToast(message: string = '操作完成', duration: number = 3000, position: string = 'bottom'): void {
    this.toastCtrl.create({
      message: message,
      duration: duration,
      position: position,
      closeButtonText: '关闭',
      showCloseButton: true
    }).present();
  };

  /**
   * 统一调用此方法显示loading
   * @param content 显示的内容
   */
  showLoading(content: string = ''): void {
    if (!this.globalData.showLoading) {
      return;
    }
    if (!this.loadingIsOpen) {
      this.loadingIsOpen = true;
      this.loading = this.loadingCtrl.create({
        spinner: 'bubbles',
        content: content
      });
      this.loading.present();
      setTimeout(() => {
        this.loadingIsOpen && this.loading.dismiss();
        this.loadingIsOpen = false;
      }, REQUEST_TIMEOUT);
    }
  };

  /**
   * 关闭loading
   */
  hideLoading(): void {
    if (!this.globalData.showLoading) {
      this.globalData.showLoading = true;
    }
    this.loadingIsOpen && this.loading.dismiss();
    this.loadingIsOpen = false;
  };

  slideClick(item: any) {
    if (item.url) {
      //如果是 http://或者https://开头的则直接调用 否则 用堆栈push
      if (item.url.startsWith('http')) {
        this.openUrlByBrowser(item.url);
      } else {
        let paramas = {};
        if (item.extraData) {
          paramas = JSON.parse(item.extraData);
        }
        ;
        this.app.getActiveNav().push(item.url, paramas).then(x => {
        }, x => {
          this.showToast('不正确的路径，请联系管理员修改');
        }).catch(x => {
          console.log('catch', x);
        });

      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/providers/NativeService.ts